import { ServicepartnerQueryParams } from "@/lib/api/resources/servicePartners";
import { ServicepartnerFilterValues } from "../types/ServicepartnerFilterValues.interface";

export const buildServicepartnerApiFilters = (
  filterValues: ServicepartnerFilterValues,
): Partial<ServicepartnerQueryParams> => {
  const apiFilters: Partial<ServicepartnerQueryParams> = {};

  if (filterValues.name) {
    apiFilters["name"] = filterValues.name;
  }

  return apiFilters;
};
